/**
 * Formate un nombre d'heures décimal (ex: 1.5) en libellé lisible (ex: 1h30).
 */
export function formatHeuresFormation(value) {
  const n = Number(value);
  if (Number.isNaN(n) || n <= 0) {
    return '0 h';
  }
  const wholeHours = Math.floor(n);
  let minutes = Math.round((n - wholeHours) * 60);
  if (minutes === 60) {
    return `${wholeHours + 1} h`;
  }
  if (minutes === 0) {
    return `${wholeHours} h`;
  }
  if (wholeHours === 0) {
    return `${minutes} min`;
  }
  return `${wholeHours}h${String(minutes).padStart(2, '0')}`;
}

/**
 * Somme des heures (gère les décimales).
 */
export function sumHeuresFormation(values) {
  return (values || []).reduce((sum, v) => sum + Number(v || 0), 0);
}

/**
 * Convertit une durée HH:MM (input type="time") en heures décimales.
 * Ex: "01:30" → 1.5
 */
export function durationTimeToDecimal(timeStr) {
  if (!timeStr || typeof timeStr !== 'string') {
    return null;
  }
  const parts = timeStr.split(':');
  if (parts.length < 2) {
    return null;
  }
  const hours = Number(parts[0]);
  const minutes = Number(parts[1]);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) {
    return null;
  }
  return hours + minutes / 60;
}

/**
 * Convertit des heures décimales en valeur HH:MM pour input type="time".
 * Ex: 1.5 → "01:30", 8 → "08:00"
 */
export function decimalToDurationTime(decimalHours) {
  const n = Number(decimalHours);
  if (Number.isNaN(n) || n <= 0) {
    return '';
  }
  const wholeHours = Math.floor(n);
  let minutes = Math.round((n - wholeHours) * 60);
  let h = wholeHours;
  if (minutes === 60) {
    h += 1;
    minutes = 0;
  }
  return `${String(h).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}
